<template>
  <div id="appf">
    <v-app id="inspire">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">{{$t('cyclic.definition')}}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2">{{ $t('cyclic.create.assign_teams')}}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">{{ $t('cyclic.create.assign_schemas')}}</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card
              class="mb-12"
            >
            <Create v-on:definition-created="definitionCreated"></Create>

          </v-card>

          </v-stepper-content>

          <v-stepper-content step="2">

            <AssignTeams v-on:team-assigned="teamAssigned" v-bind:idCyclic="idCyclic" ></AssignTeams>

          </v-stepper-content>

          <v-stepper-content step="3">
              <AssignSchemas v-on:schema-assigned="schemaAssigned" v-bind:idCyclic="idCyclic" > </AssignSchemas>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-app>
  </div>
</template>

<script>
import Create from './definition/Create.vue'
import AssignTeams from './definition/AssignTeams.vue'
import AssignSchemas from './definition/AssignSchemas.vue'

export default {
  components: {
    Create,
    AssignTeams,
    AssignSchemas
  },
  data() {
    return {
      basicValid: false,
      stepper: 1,
      idCyclic:0,
      loading: false,
      bottomNav: 3,
       e1: 0,
    }
  },
  computed: {

  },
  methods: {
    definitionCreated (id){
        this.e1=2;
        this.idCyclic=id;
        this.$store.commit("setSnack", {
          message: this.$t("cyclic.create.created", { username: this.username }) ,
          color: "success"
        })

    },
    teamAssigned (){
        this.e1=3;

        this.$store.commit("setSnack", {
          message: this.$t("cyclic.create.teams_assigned", { username: this.username }) ,
          color: "success"
        })

    },
    schemaAssigned (){
        this.$store.commit("setSnack", {
          message: this.$t("cyclic.create.schemas_assigned", { username: this.username }) ,
          color: "success"
        })
          this.$router.push({ path: '/cyclic/view/'+this.idCyclic })
    }
  },
  created() {
 }
}
</script>

<style>

</style>
